import styled from 'styled-components';

export const CardBoarder = styled.div`
  position: relative;
  border: 1px solid #ceccc7;
  border-radius: 8px;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.08);
  background-color: #fff;
`;
